import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationMethionineDiagramContent } from "./MethylationMethionineDiagram";
import { MethylationMethionineKeyContent } from "./MethylationMethionineKey";

const SvgMethylationMethionineDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 900, 1116)}
      viewBox={diagramOnly ? "0 142 1024 900" : "0 0 1024 1116"}
    >
      <g id="methylation-methionine -diagram+key" clipPath="url(#clip0_18291_211484)">
        <rect width={1024} height={diagramOnly ? 900 : 1116} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationMethionineKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationMethionineDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18291_211484">
          <rect width={1024} height={1116} fill="white" />
        </clipPath>
        <clipPath id="clip1_18291_211484">
          <rect width={1024} height={900} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationMethionineDiagramKey;
